import React from 'react'
import Dashboard2 from './../components/dashboard/index.js'
export default function Dashboard(props) {
  return (
    <Dashboard2 />
  )
}
